import React, { useState, useEffect } from 'react'
import { Badge } from '../../../components/badge'
import { Divider } from '../../../components/divider'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/table'
import { Input } from 'components/input'
import loadingImage from 'assets/images/boat-loading.gif'
import { ErrorDialog, SuccessDialog, ConfirmDialog } from 'components/custom/ResponseDialog'
import { CommonStatusDropdown } from 'components/custom/commonStatusDropdown'
import { Dropdown, DropdownButton, DropdownItem, DropdownLabel, DropdownMenu } from '../../../components/dropdown'
import { EllipsisVerticalIcon, PencilIcon } from '@heroicons/react/20/solid'

import { Pagination, PaginationList, PaginationNext, PaginationPage, PaginationPrevious } from 'components/pagination'
import { GET_CAPTAIN_SHIFT_SCHEDULE_LIST } from 'graphql/route/queries'
import { useLazyQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { customDateFormat, customTimeFormat } from 'utils/common'
import Flatpickr from 'react-flatpickr'
import 'flatpickr/dist/themes/material_blue.css'

export default function CaptainSchedule(props) {
    console.log('props-------<', props)
    const { t } = useTranslation()
    // Dialog Message
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [showSucDialog, setShowSucDialog] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [showConfirmDialog, setShowConfirmDialog] = useState(false)
    const [confirmMessage, setConfirmMessage] = useState('')

    const [scheduleList, setScheduleList] = useState(null)
    const [shiftCount, setShiftCount] = useState(0)

    // pagination
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const totalPages = Math.ceil(shiftCount / rowsPerPage)
    const [isSearch, setIsSearch] = useState(false)

    // Filter
    const [searchFilter, setSearchFilter] = useState({
        valid_from: null,
        valid_to: null,
        status_code: 'ALL',
    })

    const [getShiftList, { loading: shiftListLoading, error: shiftListError }] = useLazyQuery(
        GET_CAPTAIN_SHIFT_SCHEDULE_LIST,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.getCaptainShiftSchedule.success && data.getCaptainShiftSchedule.code === '200') {
                    setScheduleList(data.getCaptainShiftSchedule.shift_schedules)
                    setShiftCount(data.getCaptainShiftSchedule.total_count)
                    setIsSearch(false)
                }
            },
        }
    )
    const searchShifts = () => {
        getShiftList({
            variables: {
                shiftScheduleFilter: {
                    shift_schedule_id: null,
                    captain_id: null,
                    route_id: props.routeId,
                    trip_id: props.tripID,
                    valid_from: searchFilter?.valid_from || null,
                    valid_to: searchFilter?.valid_to || null,
                    status_code: searchFilter?.status_code === 'ALL' ? null : searchFilter?.status_code,
                },
                page: {
                    limit: rowsPerPage,
                    offset: page * rowsPerPage,
                },
            },
        })
    }

    useEffect(() => {
        searchShifts()
    }, [page, rowsPerPage, isSearch])

    const handlePageChange = newPage => {
        setPage(newPage)
    }
    const onClickSearch = () => {
        setPage(0)
        setIsSearch(true)
    }
    const onClickSearchClear = () => {
        console.log('DD searchFilter before clear:', searchFilter)
        setSearchFilter({
            valid_from: '',
            valid_to: '',
            status_code: 'ALL',
        })
        setIsSearch(false)
    }

    const handleErrClose = () => {
        setShowErrDialog(false)
        setErrorMessage('')
    }
    const handleSucClose = () => {
        setShowSucDialog(false)
        setSuccessMessage('')
    }
    const handleConfirmPositive = () => {
        setConfirmMessage('')
        setShowConfirmDialog(false)
    }

    const handleConfirmNegative = () => {
        setShowConfirmDialog(false)
    }

    return (
        <>
            <div className="flex flex-wrap items-end justify-between gap-12">
                <div className="w-full">
                    <div className="mt-4 mb-4 flex flex-col sm:flex-row max-w-full gap-12">
                        <div>
                            <CommonStatusDropdown
                                statusFor="CaptainShiftScheduleStatus"
                                fields={{
                                    onChange: e =>
                                        setSearchFilter({
                                            ...searchFilter,
                                            status_code: e.target.value,
                                        }),
                                    value: searchFilter?.status_code,
                                }}
                                purpose="filter"
                            />
                        </div>
                        <div className="flex items-center">
                            <label
                                htmlFor="validFrom"
                                className="block text-sm font-medium text-gray-700 mr-2 whitespace-nowrap"
                            >
                                {t('Valid From')}
                            </label>
                            <Flatpickr
                                value={searchFilter?.valid_from}
                                placeholder="yyyy/mm/dd"
                                onChange={date =>
                                    setSearchFilter({
                                        ...searchFilter,
                                        valid_from: date[0].toISOString().slice(0, 10),
                                        // valid_from: date[0] ? date[0].toLocaleDateString('en-CA').replace(/-/g, '/') : ''
                                    })
                                }
                                options={{
                                    altInput: true,
                                    altFormat: 'Y/m/d', // Display format for the date picker
                                    dateFormat: 'Y/m/d', // Format for the stored date value
                                    maxDate: new Date(),
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-xs sm:text-sm sm:leading-6"
                            />

                            {/* <Input
                                type="date"
                                id="validFrom"
                                name="validFrom"
                                value={searchFilter?.valid_from}
                                onChange={e => setSearchFilter(
                                    {
                                        ...searchFilter,
                                        valid_from: e.target.value
                                    }
                                )}
                                className="mt-1 block w-full"
                                max="2050-12-31"
                            /> */}
                        </div>
                        <div className="flex items-center">
                            <label
                                htmlFor="validTo"
                                className="block text-sm font-medium text-gray-700 mr-2 whitespace-nowrap"
                            >
                                {t('Valid To')}
                            </label>
                            <Flatpickr
                                value={searchFilter?.valid_to}
                                placeholder="yyyy/mm/dd"
                                onChange={date =>
                                    setSearchFilter({
                                        ...searchFilter,
                                        valid_to: date[0].toISOString().slice(0, 10),
                                        // valid_to: date[0] ? date[0].toLocaleDateString('en-CA').replace(/-/g, '/') : ''
                                    })
                                }
                                options={{
                                    altInput: true,
                                    altFormat: 'Y/m/d', // Display format for the date picker
                                    dateFormat: 'Y/m/d', // Format for the stored date value
                                    maxDate: new Date(),
                                }}
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-xs sm:text-sm sm:leading-6"
                            />
                            {/* <Input
                                type="date"
                                id="validTo"
                                value={searchFilter?.valid_to}
                                onChange={e => setSearchFilter(
                                    {
                                        ...searchFilter,
                                        valid_to: e.target.value
                                    }
                                )}
                                className="mt-1 block w-full"
                                max="2050-12-31"
                                min={searchFilter?.valid_from}
                            /> */}
                        </div>

                        <div className="flex gap-2 justify-end">
                            <button
                                type="button"
                                onClick={onClickSearch}
                                className="inline-flex items-center justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/[0.9]"
                            >
                                {t('Search')}
                            </button>
                            <button
                                type="button"
                                onClick={onClickSearchClear}
                                className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            >
                                {t('Clear')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Divider />
            {shiftListLoading && (
                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                    <p className="pt-3 text-primary font-semibold">Loading, please wait...</p>
                </div>
            )}
            {shiftListError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch shifts!')}</div>
                </div>
            )}
            {!shiftListLoading && !shiftListError && scheduleList?.length === 0 && (
                <div className="text-center py-24 bg-gray-50 mt-8 rounded-lg">
                    <svg
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        className="mx-auto h-12 w-12 text-gray-400"
                    >
                        <path
                            d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                            strokeWidth={2}
                            vectorEffect="non-scaling-stroke"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <h3 className="mt-2 text-sm font-semibold text-gray-900">{t('No data found!')}</h3>
                    <p className="mt-1 text-sm text-gray-500">{t('Try adjusting your search criteria')}</p>
                    <div className="mt-6"></div>
                </div>
            )}
            {!shiftListLoading && !shiftListError && scheduleList?.length > 0 && (
                <>
                    <div className="table-custom overflow-x-scroll lg:overflow-hidden rounded-b-lg bg-white p-0 flex">
                        <Table className="mt-8">
                            <TableHead>
                                <TableRow>
                                    <TableHeader>{t('Captain Name')}</TableHeader>
                                    <TableHeader>{t('Shift Time')}</TableHeader>
                                    <TableHeader>{t('Days')}</TableHeader>
                                    <TableHeader>{t('Validity')}</TableHeader>
                                    <TableHeader>{t('Status')}</TableHeader>
                                    <TableHeader className="text-right">{t('Actions')}</TableHeader>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {scheduleList.map(schedule => (
                                    <TableRow key={schedule.shift_schedule_id}>
                                        <TableCell>
                                            {schedule.captain.user_info.given_name}{' '}
                                            {schedule.captain.user_info.family_name}
                                        </TableCell>
                                        <TableCell>
                                            {customTimeFormat(schedule.start_time)} -{' '}
                                            {customTimeFormat(schedule.end_time)}
                                        </TableCell>
                                        <TableCell>
                                            {schedule.days_of_week.map(day => (
                                                <Badge key={day} color="primary" className="mr-1 capitalize">
                                                    {day}
                                                </Badge>
                                            ))}
                                        </TableCell>
                                        <TableCell>
                                            {customDateFormat(schedule.valid_from)} -{' '}
                                            {customDateFormat(schedule.valid_to)}
                                        </TableCell>
                                        {/* {formatDate(schedule.valid_from) - formatDate(schedule.valid_to)}                                        </TableCell> */}
                                        <TableCell>
                                            <Badge color={schedule.status?.code === 'ACT' ? 'emerald' : 'purple'}>
                                                {schedule.status?.description
                                                    ? schedule.status.description.en
                                                    : 'Inactive'}
                                            </Badge>
                                        </TableCell>
                                        <TableCell className="text-right">
                                            <Dropdown>
                                                <DropdownButton plain aria-label="More options">
                                                    <EllipsisVerticalIcon />
                                                </DropdownButton>
                                                <DropdownMenu anchor="bottom">
                                                    {/* <DropdownItem href={``}>
                                                        <EyeIcon />
                                                        <DropdownLabel>View</DropdownLabel>
                                                    </DropdownItem>
                                                    <DropdownDivider /> */}
                                                    <DropdownItem
                                                        href={`/metro-routes/captain-schedule-form/${schedule.shift_schedule_id}/${schedule.route_id}/${props.tripID}/${props.tripName}`}
                                                    >
                                                        <PencilIcon />
                                                        <DropdownLabel>{t('Edit')}</DropdownLabel>
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                    <Divider />

                    <Pagination className="py-6">
                        <PaginationPrevious
                            onClick={() => handlePageChange(page > 0 ? page - 1 : 0)}
                            disabled={page === 0}
                        />
                        <PaginationList>
                            {Array.from({ length: totalPages }, (_, index) => (
                                <PaginationPage
                                    key={index}
                                    current={index === page}
                                    onClick={() => handlePageChange(index)}
                                >
                                    {index + 1}
                                </PaginationPage>
                            ))}
                        </PaginationList>
                        <PaginationNext
                            onClick={() => handlePageChange(page < totalPages - 1 ? page + 1 : totalPages - 1)}
                            disabled={page === totalPages - 1}
                        />
                    </Pagination>
                </>
            )}

            <Divider />
            {showErrDialog && (
                <ErrorDialog status={true} title="Error" message={errorMessage} onClose={handleErrClose} />
            )}
            {showSucDialog && (
                <SuccessDialog status={true} title="Success" message={successMessage} onClose={handleSucClose} />
            )}

            {showConfirmDialog && (
                <ConfirmDialog
                    status={true}
                    title="Boat Status Update"
                    negativeActionText="Cancel"
                    positiveActionText="Yes"
                    message={confirmMessage}
                    onPositive={handleConfirmPositive}
                    onNegative={handleConfirmNegative}
                />
            )}
        </>
    )
}
